import KeyMetrics from "components/common/KeyMetrics/KeyMetrics";
import Typography from "components/common/Typography";
import { tokens } from "styles/Tokens";
import { tableauURL } from "utils/URLConstants";

interface ListKeyMetricsProps {
  view: string;
  listCategory: string;
  keyMetricsData: any;
}

const ListKeyMetrics = ({ view, listCategory, keyMetricsData }: ListKeyMetricsProps) => {
  return (
    <KeyMetrics
      helperText={
        listCategory === "consultant" && view === "myList"
          ? "*Results displayed are for highlighted list"
          : "*Last 90 Days"
      }
      hyperLink={
        view === "dashboard"
          ? {
              link: tableauURL,
              content: (
                <Typography variant={"label"} color={tokens.Text.General.Color}>
                  Go to Tableau for full insights.
                </Typography>
              )
            }
          : {}
      }
      keyMetricsData={keyMetricsData}
    />
  );
};

export default ListKeyMetrics;
